import { render, staticRenderFns } from "./RoutesListNewItem.vue?vue&type=template&id=b8265256&"
import script from "./RoutesListNewItem.vue?vue&type=script&lang=js&"
export * from "./RoutesListNewItem.vue?vue&type=script&lang=js&"
import style0 from "./RoutesListNewItem.vue?vue&type=style&index=0&id=b8265256&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports